import { Field, Input } from '@billda/design-system';

interface GroupNameCardProps {
  name: string;
  onChange: (name: string) => void;
  disabled?: boolean;
  autoFocus?: boolean;
  dataTestId?: string;
}

export function GroupNameCard({
  name,
  onChange,
  disabled = false,
  autoFocus = false,
  dataTestId = 'group-name-input',
}: GroupNameCardProps) {
  return (
    <div data-testid="group-name-card">
      <Field
        label="Group name"
        hint="Use a name workers and supervisors will recognise."
        required
      >
        <Input
          value={name}
          onChange={event => onChange(event.target.value)}
          placeholder="Enter group name"
          disabled={disabled}
          autoFocus={autoFocus}
          data-testid={dataTestId}
        />
      </Field>
    </div>
  );
}
